import {
    faArrowRight,
    faDice,
    faReply,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";

import { Geral } from "./Geral";
import { Respostas } from "./Respostas";

interface IEditarRespostaProps {
    IdCategoria: number;
    updateList: () => void;
}

export function EditarCategoriaRespostaChatHeader(equipeName: string) {
    return (
        <>
            <Modal.Title
                id="contained-modal-title-vcenter"
                className="card-title d-flex flex-nowrap align-items-center"
            >
                <FontAwesomeIcon icon={faArrowRight} className="mr-2" />
                <h3 className="card-label">{equipeName}</h3>
            </Modal.Title>
            <div className="card-toolbar">
                <ul
                    className="nav nav-tabs nav-bold nav-tabs-line"
                    role="tablist"
                    id="#RespostasTools"
                >
                    <li className="nav-item">
                        <a
                            className="nav-link active"
                            href="#Geral"
                            data-toggle="tab"
                            data-target="#Geral"
                            role="tab"
                        >
                            <span className="nav-icon">
                                <FontAwesomeIcon icon={faDice} />
                            </span>
                            <span className="nav-text">Geral</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#Respostas"
                            data-toggle="tab"
                            data-target="#Respostas"
                        >
                            <span className="nav-icon">
                                <FontAwesomeIcon icon={faReply} />
                            </span>
                            <span className="nav-text">Respostas</span>
                        </a>
                    </li>
                </ul>
            </div>
        </>
    );
}

function EditarCategoriaRespostaChat(props: IEditarRespostaProps) {
    return (
        <div className="tab-content" id="RespostasTools">
            <div
                className="tab-pane fade active show"
                id="Geral"
                role="tabpanel"
                aria-labelledby="Geral"
            >
                <Geral
                    IdCategoria={props.IdCategoria}
                    updateList={props.updateList}
                />
            </div>
            <div
                className="tab-pane fade"
                id="Respostas"
                role="tabpanel"
                aria-labelledby="Respostas"
            >
                <Respostas
                    IdCategoria={props.IdCategoria}
                    updateList={props.updateList}
                />
            </div>
        </div>
    );
}
export default EditarCategoriaRespostaChat;
